import actions from './actions';
import mutations from './mutations';

const state = {
	collection: null,
	collaborators: null,
	loading: false,
	initState: null,
};

export default {
	namespaced: true,
	state,
	actions,
	mutations,
};
